import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import PrivateRoute from './PrivateRoute'

import Homepage from './Homepage'
import Header from './Components/common-powerup2021/Header';
import TechnicalSessions from './Components/common-powerup2021/Attendee/TechnicalSessions';

import NotFound from './Components/common-powerup2021/NotFound';

import WorkProgress from './Components/common-powerup2021/WorkProgress';
import Login from './Components/common-powerup2021/Login';
import LoginSingleSignOn from './Components/common-powerup2021/LoginSingleSignOn';
import Register from './Components/common-powerup2021/Register';

import AboutSession from './Components/common-powerup2021/Attendee/AboutSession';
import ResetPassword from './Components/common-powerup2021/ResetPassword';
import DashboardSpeaker from './Components/common-powerup2021/Speaker/Dashboard';
import ProfileDetails from './Components/common-powerup2021/Speaker/ProfileDetails';

import ExhibitorDetails from './Components/common-powerup2021/Exhibitor/ExhibitorDetails';
import ExhibitorBooth from './Components/common-powerup2021/Exhibitor/ExhibitorBooth';

import Dashboard from './Components/common-powerup2021/Exhibitor/Dashboard';
import LoginSplash from './Components/common-powerup2021/LoginSplash';
import SingleSignOn from './Components/common-powerup2021/SingleSignOn';

import Lobby from './Components/common-powerup2021/Attendee/Lobby';
import ExhibitHall from './Components/common-powerup2021/Attendee/ExhibitHall';
import NetworkingLounge from './Components/common-powerup2021/Attendee/NetworkingLounge';
import ConferenceCenter from './Components/common-powerup2021/Attendee/ConferenceCenter';
import ConferenceCenterPage from './Components/common-powerup2021/Attendee/ConferenceCenterPage';
import TrackConferenceDetail from './Components/common-powerup2021/Attendee/TrackConferenceDetail';
import ExhibitList from './Components/common-powerup2021/Attendee/ExhibitList';
import Session from './Components/common-powerup2021/Attendee/Session';

import HelpDesk from './Components/common-powerup2021/Attendee/HelpDesk';
import GoldenTicket from './Components/common-powerup2021/Attendee/GoldenTicket';
import AttendeeExhibitorBooth from './Components/common-powerup2021/Attendee/AttendeeExhibitorBooth';

import UserProfile from './Components/common-powerup2021/UserProfile';

import ChatPage from "./TmChat/common-powerup2021/chat/ChatPage";
import VideoCall from "./TmChat/common-powerup2021/video/VideoCall";
import ConferenceMeeting from "./TmChat/common-powerup2021/videoConference/conferenceMeeting";
import Meetings from "./TmChat/common-powerup2021/videoConference/meetings";
/* import test from './Components/common-powerup2021/Exhibitor/test'; */

class Commonpowerup2021 extends Component {
constructor(){
  super();

  this.state={
    homePage:""
  }
}
componentDidMount(){
  //console.log(window.location.href)
  
}

  render() {

    const domain = window.location.href
    if(domain === ("http://localhost:3000/" || "https://affectionate-bohr-4d306b.netlify.app/")){
      return(
        <div className="App">
            <Router>
              <Route path="/" exact component={Homepage} />
              {/* <Route path="/home" exact component={Homepage} /> */}
            </Router>
        </div>
      )
    }
    else {
      return (
      <Router>
          <div className="App">
            
            <Header/>
            <Switch>
                
                <Route path="/common-powerup2021/sessionList" component={TechnicalSessions} />
                <Route path="/common-powerup2021/login/:loginId" component={Login} />
                <Route path="/common-powerup2021/loginSingleSignOn/:loginId" component={LoginSingleSignOn} />
                <Route path="/common-powerup2021/resetPassword" component={ResetPassword} />
                <Route path="/common-powerup2021/register" component={Register} />
                <Route path="/common-powerup2021/single-signon/:eventId/:emailId/:tokenpass" exact component={SingleSignOn} />
                <Route path="/common-powerup2021/attendee/aboutsession/:sessionId" component={AboutSession} />
                <Route path="/common-powerup2021/workProgress" exact component={WorkProgress} />
                <PrivateRoute path="/common-powerup2021/loginSplash" exact component={LoginSplash} />
                <PrivateRoute path="/common-powerup2021/speaker/dashboard" exact component={DashboardSpeaker} />
                <PrivateRoute path="/common-powerup2021/speaker/profile" exact component={ProfileDetails} />
                <PrivateRoute path="/common-powerup2021/exhibitor/dashboard" exact component={Dashboard} />
                <PrivateRoute path="/common-powerup2021/exhibitor/profile" exact component={ExhibitorDetails} />
                <PrivateRoute path="/common-powerup2021/exhibitor/booth" component={ExhibitorBooth} />

                <PrivateRoute path="/common-powerup2021/chat" exact component={ChatPage} />
                <PrivateRoute path="/common-powerup2021/video-call" exact component={VideoCall} />
                <PrivateRoute path="/common-powerup2021/video-conference" exact component={Meetings} />
                <PrivateRoute path="/common-powerup2021/conference-meeting/:id" exact component={ConferenceMeeting} />

                <PrivateRoute path="/common-powerup2021/attendee/lobby" component={Lobby} />
                <PrivateRoute path="/common-powerup2021/attendee/exhibitHall" component={ExhibitHall} />
                <PrivateRoute path="/common-powerup2021/attendee/networkingLounge" component={NetworkingLounge} />
                <PrivateRoute path="/common-powerup2021/attendee/conferenceCenter" component={ConferenceCenter} />
                <PrivateRoute path="/common-powerup2021/attendee/session" component={Session} />
                <PrivateRoute path="/common-powerup2021/attendee/conferenceCenterDetails/:sessionId" component={ConferenceCenterPage} />
                <PrivateRoute path="/common-powerup2021/attendee/trackConferenceDetail/:trackId" component={TrackConferenceDetail} />
                <PrivateRoute path="/common-powerup2021/attendee/technicalSessions" component={TechnicalSessions} />
                <PrivateRoute path="/common-powerup2021/attendee/exhibitList" component={ExhibitList} />
                <PrivateRoute path="/common-powerup2021/attendee/helpDesk" component={HelpDesk} />
                <PrivateRoute path="/common-powerup2021/user/profile" exact component={UserProfile} />
                <PrivateRoute path="/common-powerup2021/attendee/goldenTicket" component={GoldenTicket} />
                <PrivateRoute path="/common-powerup2021/attendee/exhibitorBooth/:exhibitorId" component={AttendeeExhibitorBooth} />
                <Route path="*" component={NotFound} />
              </Switch>
         
          </div>
      </Router>
    );}
  }  
}

export default Commonpowerup2021;
